/**
 * Copyright (c) 2017.  INTERIA.PL (www.interia.pl)
 **/

/**
 * Created by vladyslav on 27.11.17.
 */

export default class AdSidebarService {

    constructor(sidebar) {

        this.sidebar = sidebar;
        this.contentSelector = null;
        this.adsSidebarSelector = null;

    }

    set contentSelector(contentSelector) {
        this._contentSelector = contentSelector;
    }

    get contentSelector() {
        return this._contentSelector;
    }

    set adsSidebarSelector(adsSidebarSelector) {
        this._adsSidebarSelector = adsSidebarSelector;
    }

    get adsSidebarSelector() {
        return this._adsSidebarSelector;
    }

    /**
     * update ads positions
     */
    updateAdsPositions() {
        this.sidebar.ads.forEach(ad => ad.updatePosition(this.sidebar));
    }

    /**
     * calculate ads visibility ranges
     */
    calcVisibilityRanges() {
        const sidebar = this.sidebar;

        this.sidebar.ads.forEach(ad => ad.calcVisibilityRange(sidebar));
    }
}



// WEBPACK FOOTER //
// ./source/AdSidebarService.js